'use strict';

define('lib/analytics/blocks/offer.block',[], function () {
  return function offerBlock(offer) {
    // right now, when an offer is run through offers.tmpl.common xform
    // it gets an offer.dataLayer. If thats the case, just return it
    // otherwise it will need to be built
    var providedDl = offer.dataLayer;
    if (providedDl && providedDl.link_text) {
      delete providedDl.link_text;
    }

    return providedDl || {
      offer_category: '',
      offer_type: '',
      offer_id: '',
      offer_expired_date: '',
      offer_term: '',
      offer_rate: '',
      offer_amtdue: '',
      offer_monthly: '',
      offer_cashback: '',
      offer_title: '',
      offer_label: '',
      offer_series_code: '',
      offer_series_year: '',
      offer_series_number: '',
      offer_series_vehicleid: '',
      offer_series_inventory_type: 'New',
      offer_series_brand: 'Toyota',
      offer_series_category: '',
      offer_series_fuel_type: '',
      offer_series_msrp: '',
      offer_series_grade: '',
      offer_series_engine: '',
      offer_series_transmission: '',
      offer_series_body_style: '',
      offer_series_packages: '',
      offer_series_color_ext: '',
      offer_series_color_int: '',
      offer_series_color_ext_code: '',
      offer_series_color_int_code: '',
      offer_series_accessories_name: '',
    };
  };
});

